export const constructFormData = (file, reqBody)=>{
    const formData = new FormData();
    const fileMeta = {
        ...reqBody,
        attachment: {
            name: file === null || file === void 0 ? void 0 : file.name,
            // TODO: Work attachments privacy once we've a solution for email attachments.
            publicVisibility: true,
            ...reqBody.attachment
        }
    };
    const json = JSON.stringify(fileMeta);
    const blob = new Blob([
        json
    ], {
        type: 'application/json'
    });
    formData.append('file', file);
    formData.append('request', blob);
    return formData;
};
